export default {
  Coordenador: 1,
  Funcionario: 2,
  Aluno: 3,
  Fornecedor: 4,
  Importacao: 5,
  AcessoEspecial: 6,
  FornecedorWeb: 7,
  FornecedorWebNovo: 8,
  PessoaFisica : 9,
  PessoaFisicaWeb : 10,
  PessoaFisicaWebNovo: 11,
  UsuarioChat: 12,
  GestaoAssinatura: 13,
  GestaoConciliacao: 14,
  GestaoMensagens: 15,
}



// WEBPACK FOOTER //
// ./FrontEnd/js/tipo-usuario.js